import React from "react";

import { Rule } from "./Rule.tsx";
import { Button } from "../../../../Components/ui/button.tsx";

import { CopyIcon, PlusIcon, TrashIcon } from "lucide-react";

import { useLogicStore } from "../../store/use-logic-store.ts";

import { ActionType } from "../../types/zustand.ts";
import { Logic, OPERATOR } from "../../types/logic.ts";
import { useFormEditorContext } from "../../../../Contexts/FormEditorContext.jsx";
import { useLogicV2 } from "../../hooks/use-logic-v2.ts";

type GroupProps = {
    id: string;
    branchId: string;
};

export function Group({ id, branchId }: GroupProps) {
    const { logics, selectedField } = useFormEditorContext();
    const { dispatch } = useLogicV2();
    const activeFieldId = selectedField?.id;
    const logic = (logics as Logic[]).find(
        (logic) => logic.fieldId === activeFieldId,
    );

    if (!logic) return null;

    const branch = logic.branches.find((branch) => branch.id === branchId);

    if (!branch) return null;

    const group = branch.groups.find((group) => group.id === id);

    if (!group) return null;

    const handleAddRule = () => {
        dispatch({
            type: ActionType.ADD_RULE,
            payload: {
                groupId: id,
                sourceId: "",
                operator: OPERATOR.EQUAL,
                expectedValue: "",
            },
        });
    };

    const handleRemoveGroup = () => {
        dispatch({
            type: ActionType.REMOVE_GROUP,
            payload: {
                groupId: id,
            },
        });
    };

    const handleDuplicateGroup = () => {
        dispatch({
            type: ActionType.DUPLICATE_GROUP,
            payload: {
                groupId: id,
            },
        });
    };

    return (
        <div className="bg-white rounded-[8px] p-2 flex flex-col w-full items-start">
            <div className="flex flex-row items-center justify-between w-full">
                <p className="text-sm font-medium">{group.name}</p>
                <div className="flex flex-row items-center">
                    <Button
                        variant="ghost"
                        size="icon"
                        className="w-[27px] h-[27px]"
                        onClick={handleDuplicateGroup}
                    >
                        <CopyIcon className="w-4 h-4 text-gray-700" />
                    </Button>
                    <Button
                        variant="ghost"
                        size="icon"
                        className="w-[27px] h-[27px]"
                        onClick={handleRemoveGroup}
                    >
                        <TrashIcon className="w-4 h-4 text-gray-700" />
                    </Button>
                </div>
            </div>

            <div className="flex flex-col gap-3 mt-3 w-full">
                {group.rules.map((rule, index) => (
                    <Rule
                        key={rule.id}
                        id={rule.id}
                        index={index}
                        groupId={id}
                        branchId={branchId}
                    />
                ))}
            </div>

            <Button
                variant="outline"
                className="mt-3 rounded-[6px] py-[6px] px-2 text-xs text-[#191B33] font-medium w-fit h-fit"
                onClick={handleAddRule}
            >
                <PlusIcon className="w-4 h-4 mr-[3px] text-gray-700" />
                Add Rule
            </Button>
        </div>
    );
}
